<template>
  <div id="app">
    <Header/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  head: {
    meta: [
      { name: 'msapplication-TileColor', content: '#da532c' },
      { name: 'theme-color', content: '#ffffff' }
    ],
    link: [
      { rel: 'apple-touch-icon', href: require('../static/apple-touch-icon.png'), sizes: '180x180' },
      { rel: 'icon', href: require('../static/favicon-32x32.png'), sizes: '32x32', type: 'image/png' },
      { rel: 'icon', href: require('../static/favicon-16x16.png'), sizes: '16x16', type: 'image/png' },
      { rel: 'icon', href: require('../static/favicon.ico'), type: 'image/icon' },
      { rel: 'manifest', href: require('../static/site.webmanifest') },
      { rel: 'mask-icon', href: require('../static/safari-pinned-tab.svg'), color: '#5bbad5' }
    ]
  }
}
</script>

<style lang="scss">
  @import "/assets/scss/style.scss";
  @import "/assets/scss/mixins.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue